export const salaryCompassGiftResponseMocks = {
    requested: true,
    delivered: false
};
//# sourceMappingURL=salary-compass-gift-response.mocks.js.map